import { getStorageUrl } from 'store/settings/selectors';
import { getCourseTitle, getCourseId, getTemplateId } from 'store/course/selectors';
import requester from 'core/http/requester';
import { CONTENT_TYPES } from 'constants/common';
import StorageInterface from '../storageInterface';
import ExternalStorageAuth from './auth';
import SocialNetworks from './socialNetworks';

class ExternalStorage extends StorageInterface {
  constructor(state) {
    super();

    this.courseId = getCourseId(state);
    this.templateId = getTemplateId(state);
    this.storageUrl = getStorageUrl(state);

    let courseTitle = getCourseTitle(state);

    this._auth = new ExternalStorageAuth(courseTitle, this.storageUrl);
    this._socialNetworks = new SocialNetworks(courseTitle, this.storageUrl);
  }

  async getProgress() {
    if (!this._auth.token) {
      return;
    }

    let response = await requester.get(`${this.storageUrl}/progress`, {
      query: {
        courseId: this.courseId,
        templateId: this.templateId
      },
      headers: this._auth.getHeaders(CONTENT_TYPES.JSON)
    });

    let data = await response.json();
    return data && JSON.parse(data.progress);
  }

  async saveProgress(progress) {
    return requester.post(`${this.storageUrl}/progress`, {
      data: {
        courseId: this.courseId,
        templateId: this.templateId,
        jsonProgress: progress ? JSON.stringify(progress) : null
      },
      headers: this._auth.getHeaders(CONTENT_TYPES.JSON),
      nocache: true
    });
  }

  async removeProgress() {
    return requester.post(`${this.storageUrl}/progress`, {
      data: {
        courseId: this.courseId,
        templateId: this.templateId,
        jsonProgress: null
      },
      headers: this._auth.getHeaders(CONTENT_TYPES.JSON),
      nocache: true
    });
  }

  isAuthenticated() {
    return this._auth.isAuthenticated();
  }

  async userExists(email) {
    return this._auth.exists(email);
  }

  async identifyUser() {
    return this._auth.identify();
  }

  async authorizeUser(userData) {
    return this._auth.authorize(userData);
  }

  async registerUser(userData) {
    return this._auth.register(userData);
  }

  async resetPassword(email) {
    return this._auth.resetPassword(email);
  }

  logout() {
    this._auth.logout();
  }

  getSocialNetworkAuthLink(socialNetwork) {
    return this._socialNetworks.getAuthLink(socialNetwork);
  }

  async sendSecretLink(secretLinkData) {
    return this._auth.sendSecretLink(secretLinkData);
  }

  getHeaders(contentTypes) {
    return this._auth.getHeaders(contentTypes);
  }

  getToken() {
    return this._auth.token;
  }
}

export default ExternalStorage;
